module.exports = __webpack_public_path__ + "img/cert11.f114c014.png";